import * as yup from 'yup'

export const securitySchema = yup.object({
  code: yup
    .string()
    .required('Please enter the security code')
    .typeError('Please enter a valid number'),
})
